import React, { useEffect } from 'react';
import ImageSwipe from './ImageSwipe';
import './Partnerships.css';

const Partnerships = () => {
    // Scroll to the top of the scroll container when the page loads
    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-container');
        if (scrollContainer) {
            scrollContainer.scrollTo(0, 0);
        }
    }, []);

    return (
        <div className="partnerships-page container">
            <section className="bento-grid section-gap">
                <div className="bento-cell tactical-border partnerships-hero">
                    <div className="tactical-label">Partnerships & Ventures</div>
                    <img
                        src="/images/reef_arches_logo_webp.webp"
                        alt="Reef Arches Logo"
                        className="hero-logo"
                    />
                    <h1 className="glow-text">Official Distributor For Belize</h1>
                    <p className="hero-description">
                        Aerogen, Inc. is the official distributor of Reef Arches for Belize, delivering patented,
                        nature-based engineered structures designed to rebuild shorelines, attenuate wave energy,
                        and provide critical habitat for marine wildlife.
                    </p>
                    <a href="https://reefarches.com" target="_blank" rel="noopener noreferrer" className="button-style">
                        Explore Reef Arches
                    </a>
                </div>
            </section>

            <section className="bento-grid section-gap">
                <div className="bento-cell" style={{ padding: 0 }}>
                    <ImageSwipe
                        beforeImage="/images/before.jpg"
                        afterImage="/images/after.jpg"
                        beforeLabel="Before Installation"
                        afterLabel="After Installation"
                    />
                </div>
            </section>

            <section className="bento-grid section-gap features-grid">
                <div className="bento-cell">
                    <div className="tactical-label">Architecture</div>
                    <h3>Honeycomb Design</h3>
                    <p>
                        The unique honeycomb arch-shaped design revolutionizes coastal restoration by
                        effectively recruiting sediment and attenuating wave energy. The design offers an
                        impressive 100 square feet of surface area per unit.
                    </p>
                </div>

                <div className="bento-cell">
                    <div className="tactical-label">Application</div>
                    <h3>Coastal Protection</h3>
                    <p>
                        Specifically crafted for nearshore environments, focusing on protecting coastlines
                        from severe erosion. They provide essential structural support to stabilize shorelines,
                        reduce wave impact, and foster resilient coastal habitats.
                    </p>
                </div>

                <div className="bento-cell">
                    <div className="tactical-label">Sustainability</div>
                    <h3>Eco-Friendly</h3>
                    <p>
                        With a minimal ground footprint and the ability to be stacked, Reef Arches ensure
                        a robust and eco-friendly approach to coastal engineering and habitat creation.
                    </p>
                </div>
            </section>

            <section className="bento-grid section-gap features-grid">
                <div className="bento-cell">
                    <div className="tactical-label">Mission</div>
                    <h3>Who We Serve</h3>
                    <p>
                        Pioneering nature-based engineered structures designed to rebuild shorelines
                        and provide critical habitat for wildlife, tailored for the unique coastal
                        environments of Belize.
                    </p>
                </div>

                <div className="bento-cell">
                    <div className="tactical-label">Restoration</div>
                    <h3>Marine Ecosystems</h3>
                    <p>
                        Engineered to be safe for marine life—including corals and sponges.
                        We place habitat restoration at the core of our design, creating structures
                        that don't just protect coastlines but actively support thriving marine ecosystems.
                    </p>
                </div>

                <div className="bento-cell">
                    <div className="tactical-label">Innovation</div>
                    <h3>Living Seawalls</h3>
                    <p>
                        Our innovative Reef Arch Seawall tiles convert barren concrete barriers into
                        vibrant, healthy habitats. This dual-purpose solution turns vertical structures
                        into productive marine environments while providing coastal protection at scale.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default Partnerships;
